import React from "react";

class ClaimCustomizeIframe extends React.Component {

  componentDidMount() {
    this.buildIframe()
    PubSub.subscribe('fetchCustomizeIframe', () => this.forceUpdate())
  }

  componentDidUpdate() {
    this.buildIframe()
  }

  componentWillUnmount() {
    PubSub.unsubscribe('fetchCustomizeIframe')
  }

  buildIframe() {
    const content = _getDescription(this.props.content)
    const baseUrl = `${window.location.protocol}//${window.location.host}`;
    let headHtml = '';
    headHtml += `<link type="text/css" rel="stylesheet" href=${baseUrl}/assets/skins/content/default/content.min.css>`;
    headHtml += `<link type="text/css" rel="stylesheet" href=${baseUrl}/assets/plugins/a11ychecker/css/annotations.css>`;
    headHtml += `<link type="text/css" rel="stylesheet" href=${baseUrl}/assets/plugins/mediaembed/content.min.css>`;
    headHtml += `<link type="text/css" rel="stylesheet" href=${baseUrl}/assets/plugins/linkchecker/content.min.css>`;
    headHtml += `<link type="text/css" rel="stylesheet" href=${baseUrl}/assets/custom_tinymce.sass>`;
    headHtml += `<link type="text/css" rel="stylesheet" href=${baseUrl}/assets/graphik.css>`;
    const bodyClass = '';
    const preventClicksOnLinksScript = `<script>document.addEventListener && document.addEventListener("click", function(e) {for (var elm = e.target; elm; elm = elm.parentNode) {if (elm.nodeName === "A") {e.preventDefault(); window.open(elm.href);}}}, false);</script> `;
    const collapseableScript = `<script>
      function resizeContainer(iframe) {
        body = iframe.contentWindow.document.body
        iframe.style.height = body.scrollHeight + 50 + "px";
      };
      function toggleCollapsableDiv(hideNode) {
        var div = hideNode.parentElement.parentElement.querySelector(".tinymce-template-collapsing-div");
        if (div.style.display == "none") {
          div.style.display = "";
          hideNode.textContent = "Hide";
        } else {
          div.style.display = "none";
          hideNode.textContent = "Show";
        }
      };
      if (document.addEventListener) {
        var selectors = document.querySelectorAll(".tinymce-template-collapsing-button");
        for (var i=0; i < selectors.length; i++) {
          toggleCollapsableDiv(selectors[i]);
          selectors[i].addEventListener("click", function(e) {
            var element = e.target;
            toggleCollapsableDiv(element)
            resizeContainer(window.frameElement)
          });
        }
      }
    </script> `
    const iframeBody = `<!DOCTYPE html><html><head>${headHtml}</head><body id="tinymce" class="mce-content-body description-preview">${_getDescription(content)}${preventClicksOnLinksScript}${collapseableScript}</body></html>`;
    const iframe = document.createElement('iframe');
    iframe.setAttribute('class', 'iframe-modal benefit-detail resizable-iframe');
    iframe.setAttribute('frameborder', '0');
    iframe.setAttribute('scrolling', 'no');
    const iframe_description = $('.item-detail-description-view')[0];
    iframe_description.innerHTML = '';
    iframe_description.appendChild(iframe);
    iframe.contentWindow.document.open();
    iframe.contentWindow.document.write(iframeBody);
    iframe.contentWindow.document.close();
    setTimeout((() => resizeIframe()), 100);
  }

  render() {
    return (
      <div
        className="col-md-12 item-detail-description-view"
        style={{ paddingBottom: '0px' }}
      />
    )
  }
}

export default ClaimCustomizeIframe;
